import { PanelToolBase, PanelToolGroupNames } from '@addins/core/panel';
import { ToggleTool } from '@techwan/map-tools';
import { StatusListComponent } from '../components/status-list/status-list.component';

export class StatusPanelTool extends PanelToolBase {
  readonly groupName: string = PanelToolGroupNames.StatusToolGroup;
  readonly button: ToggleTool = new ToggleTool('status-tool-button', ['person-circle-outline', 'person-circle']);
  readonly content = StatusListComponent;
}
